import { Lesson } from "@jelly/lesson";
import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "176d927f-ab07-4b94-9f0f-1bcca4aae3a9",
  publicId: "25",
  name: "Statistical evaluation of listening experiments [Statistical analysis of a listening experiment]",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01, task02],
};

export default lesson;
